import { clone } from '@jack-henry/frontend-utils/functions';
import { WireCompanyModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';
import { WireCompanyAccount } from './wire-company-account.entity';

const nullWireCompany: WireCompanyModelDto = {
    id: 0,
    name: '',
    updatedBy: undefined,
    updatedDate: '',
    perTransactionLimit: 0,
    dailyLimit: 0,
    isInternationalDisabled: false,
    canSelect: false,
    isDli: false,
    companyGuidUniqueId: '',
};

export class WireCompany extends DomainEntity<WireCompanyModelDto> {
    constructor(dto = clone(nullWireCompany)) {
        super(dto);
    }

    public createDefault(): this {
        return new WireCompany(clone(nullWireCompany)) as this;
    }

    public get name() {
        return this.dto.name;
    }

    public get id() {
        return this.dto.id;
    }

    public get dailyLimit() {
        return this.dto.dailyLimit;
    }

    public get perTransactionLimit() {
        return this.dto.perTransactionLimit;
    }

    public get cifNumber() {
        return this.dto.cifNumber;
    }

    public get accounts() {
        return (this.dto.accounts ?? []).map(account => new WireCompanyAccount(account));
    }

    public set accounts(accounts: WireCompanyAccount[]) {
        this.dto.accounts = accounts.map(account => account.toDto());
    }

    public set wireCompanyAccounts(accounts: WireCompanyAccount[]) {
        this.dto.wireCompanyAccounts = accounts.map(account => account.toDto());
    }

    public get canSelect() {
        return this.dto.canSelect;
    }
}
